import { render } from "./UploadButton.vue?vue&type=template&id=76a3c768&ts=true"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"

import "./UploadButton.vue?vue&type=style&index=0&id=76a3c768&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__